// extracted by mini-css-extract-plugin
module.exports = {"carouselImg":"_3mGld","container":"_2SYcb","thumb":"_1GbkH","big":"_31Dr_","active":"XOeOn","thumbs":"_3Lzv_","thumbBar":"_2_arl","thumbActive":"_2exxV"};